import { SWReactIcons } from "@similarweb/icons";
import { StyledExportInfoContainer, StyledExportInfoText } from "./styles";

type ExportInfoMessageProps = {
    children: string;
    className?: string;
};

const ExportInfoMessage = ({ children, className }: ExportInfoMessageProps) => {
    return (
        <StyledExportInfoContainer className={className}>
            <SWReactIcons
                iconName="info"
                size="xs"
            />
            <StyledExportInfoText>{children}</StyledExportInfoText>
        </StyledExportInfoContainer>
    );
}

export default ExportInfoMessage;
